import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { SectionHeader } from '../ui/SectionHeader';
import styles from './ServicesSection.module.css';

export const ServicesSection = () => {
  const { t } = useTranslation();
  const [ref, visible] = useScrollReveal(0.1);

  const pillars = [
    {
      icon: (
        <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
      ),
      title: t('services.pillar1.title'),
      desc: t('services.pillar1.desc'),
      features: t('services.pillar1.features', { returnObjects: true }) as string[],
    },
    {
      icon: (
        <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      title: t('services.pillar2.title'),
      desc: t('services.pillar2.desc'),
      features: t('services.pillar2.features', { returnObjects: true }) as string[],
    },
  ];

  return (
    <section id="services" className={styles.section} ref={ref as React.RefObject<HTMLElement>}>
      <div className="container">
        <SectionHeader
          label={t('services.label')}
          title={t('services.title')}
        />

        <div className={styles.pillars}>
          {pillars.map((pillar, idx) => (
            <div
              key={idx}
              className={`${styles.pillar} ${visible ? styles.pillarVisible : ''}`}
              style={{ transitionDelay: `${idx * 200}ms` }}
            >
              <div className={styles.pillarIcon}>{pillar.icon}</div>
              <h3 className={styles.pillarTitle}>{pillar.title}</h3>
              <p className={styles.pillarDesc}>{pillar.desc}</p>
              <div className={styles.features}>
                {pillar.features.map((f, fIdx) => (
                  <div key={fIdx} className={styles.feature}>
                    <span className={styles.featureDot} />
                    {f}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
